// @flow
import context from 'app/common/lib/context';
import ContextLogger from 'app/common/lib/ContextLogger';
import logStats from 'app/common/lib/logStats';
import pwaType from 'app/common/lib/pwaType';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import uuidV4 from 'uuid/v4';

const ONE_HOUR = 3600000;

const currentNs = () => Date.now() * 1000000;

function sendActiveUserPing() {
  /**
   * The following route checks represent routes on the site where we do not want to send a DAU ping
   */
  if (
    window.location.pathname !== '/pin/create/button/' &&
    !/guid/.test(window.location.href) &&
    !window.location.pathname.startsWith('/email/subscription')
  ) {
    const { view_type, view_parameter } =
      ContextLogger.getInstance() && ContextLogger.getInstance().getViewFromContext();
    const currentPwaType = pwaType(window);

    const eventDict = {
      data: {
        browser: context.instance.browser_type,
        clientUUID: uuidV4(),
        event_type: PCONST.thrift.EventType.USER_ACTIVE,
        time: currentNs,
        view_type,
        view_parameter,
        unauth_id: context.instance.unauth_id,
        appVersion: context.initialPageContext.appVersion,
        auxData: {
          pwa_type: currentPwaType && currentPwaType !== 'unknown' ? currentPwaType : undefined,
          stage: context.initialPageContext.stage,
        },
      },
    };

    const activeUserResource = ResourceFactory.create('ActiveUserResource', eventDict);

    let interval = 30000; // 30 seconds
    // retry via exponential backoff for up to 1 hour interval
    activeUserResource.callCreate().catch((error) => {
      const logMessage = Object.assign({}, error.message);
      // we don't need the translated string logged
      if (logMessage && logMessage._t_message) {
        delete logMessage._t_message;
      }
      logStats.increment('webapp.metrics.dau.errors', 1, {
        message: logMessage,
        browser: context.instance.browser_type,
        error_code: error.api_error_code,
        is_auth: context.instance.is_authenticated,
      });
      setTimeout(() => {
        if (interval > ONE_HOUR) {
          return;
        }
        interval *= 2;
        activeUserResource.callCreate();
      }, interval);
    });
  }
}

export default sendActiveUserPing;
